import { Flex, Separator } from 'components/base/layout-components';
import { getColor } from 'common/constants/_colors';
import PeopleEffortSummary from './PeopleEffortSummary';
import PeopleEffortOverTimeColumn from './PeopleEffortOverTimeColumn';

const PeopleEffortColumn = ({ projectConfig, project, isLastIteration }) => {
  const { iterations } = project;
  return (
    <Flex>
      <PeopleEffortSummary
        projectConfig={projectConfig}
        project={project}
        shouldShowAvgPerDuration={false}
      />
      {!isLastIteration && (
        <>
          <Separator
            height='3.5rem'
            margin='0 1rem'
            color={getColor('catskillWhite')}
          />
          <PeopleEffortOverTimeColumn iterations={iterations} />
        </>
      )}
    </Flex>
  );
};

export default PeopleEffortColumn;
